import styled from 'styled-components';

import { SelectButton as ProductCardSelectButton } from '../ProductCard/ProductCard.style';

export const SelectButton = styled(ProductCardSelectButton)<{
  disabled: boolean;
}>`
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
  margin-top: initial;
  margin-bottom: initial;
`;
